import React from "react";
import { StarIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="bg-white px-4 py-16 md:py-24" aria-labelledby="testimonials-title" data-id="element-265" data-mp="3mf7pufvy5mbi">
      <div className="mx-auto max-w-6xl" data-id="element-266" data-mp="3r8akkrcgn1ta">
        <SectionHeading eyebrow="Real feedback" title={<span id="testimonials-title" data-id="element-268" data-mp="o94cji1v1v">What other Occupational Therapists are saying</span>} data-id="element-267" data-mp="17u624g4zk4" />

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-269" data-mp="40zu5qfrxxdv">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-cream p-6 ring-1 ring-sand" data-id="element-270" data-mp="8zt7niv29oe1">
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-271" data-mp="dywbx137vqky">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-272" data-mp="2frkcf2oh7zx1" data-mpi={i} />)}
              </div>
              <p className="mt-4 font-serif text-xl font-extrabold leading-snug text-ink" data-id="element-273" data-mp="1sm3vxu0ni4f4">“{t.title}”</p>
              <blockquote className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-274" data-mp="1nshukxzxtmym">{t.quote}</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-275" data-mp="1iuziiyqmirme">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-white" loading="lazy" data-id="element-276" data-mp="1eufldv61vo09" />
                <span data-id="element-277" data-mp="26i7ntgo1y0of">
                  <span className="block font-bold text-ink" data-id="element-278" data-mp="22ip6svzcq9qv">{t.name}</span>
                  <span className="text-sm text-muted" data-id="element-279" data-mp="22ktfrsc3xyy0">{t.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-280" data-mp="r4bjptcf9ybw">
          <CtaButton label="I want to organize my cases too" data-id="element-281" data-mp="r1h0u6924lkl" />
        </div>
      </div>
    </section>;
}